module.exports = __webpack_public_path__ + "img/21.9b50ba3c.jpg";